import { lazy } from 'react';
import { Permission, type SkillManifest } from '@brandschutz/shared';
import type { FrontendSkill } from '../_core/registry';

/**
 * Schlanker Skill-Descriptor für das Bootstrap — Slot-Renderer ist React.lazy,
 * sodass die Input-Inbox erst lädt, wenn der Tab-Slot rendert.
 */
const manifest: SkillManifest = {
  key: 'input-repository',
  name: 'Input-Repository',
  description:
    'Pro Projekt eine Inbox aller Inputs — Dokumente, Clipboard-Schnipsel, Notizen, Mail-Bodies — mit Apply-to-Field.',
  category: 'data',
  version: '0.1.0',
  requiredPermissions: [Permission.PROJECT_READ, Permission.PROJECT_UPDATE],
  enabledByDefault: true,
};

const InputInbox = lazy(() => import('./InputInbox').then((m) => ({ default: m.InputInbox })));

export const inputRepositorySkill: FrontendSkill = {
  manifest,
  slots: {
    'project-detail.tabs': [
      {
        key: 'input-inbox',
        order: 40,
        // @ts-expect-error Slot context shape ist dynamic — Caller liefert projectId + readOnly
        render: InputInbox,
      },
    ],
  },
};
